module.exports = __webpack_public_path__ + "img/cake.e35fd076.svg";